/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_NoteInputs */



/**
* | output |
* | --- |
* | "If no groups are selected, all team members can access this folder." |
*
* @param {Explorer_Info_Permissions_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_note = /** @type {((inputs?: Explorer_Info_Permissions_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si aucun groupe n'est selectionne, tous les membres de l'equipe peuvent acceder a ce dossier.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn keine Gruppen ausgewählt sind, können alle Teammitglieder auf diesen Ordner zugreifen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Se non viene selezionato alcun gruppo, tutti i membri del team potranno accedere a questa cartella.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Если группы не выбраны, доступ к этой папке имеют все члены команды.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Si no se selecciona ningún grupo, todos los miembros del equipo pueden acceder a esta carpeta.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如果没有选择任何组，则所有团队成员都可以访问此文件夹。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループが選択されていない場合は、すべてのチーム メンバーがこのフォルダーにアクセスできます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यदि कोई समूह चयनित नहीं है, तो टीम के सभी सदस्य इस फ़ोल्डर तक पहुंच सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Se nenhum grupo for selecionado, todos os membros da equipe poderão acessar esta pasta.")
	return /** @type {LocalizedString} */ ("If no groups are selected, all team members can access this folder.")
});